const state = {
    menu: true,
    error: '',
    success: ''
}

const getters = {
    getMenu( state ) {
       return state.menu;
    },

    getErrror( state ) {
        return state.error;
    },

    getSuccess( state ) {
        return state.success;
    }
}

const mutations = {
    SET_MENU(state, data) {
       state.menu = data;
    },

    SET_TOGGLE(state) {
        state.menu = !state.menu;
    },

    SET_ERROR(state, data) {
        state.error = data;
    },

    SET_SUCCESS(state, data) {
        state.success = data;
    },
}

const actions = {
    toggleMenu({ commit }, data) {
        if(data !== undefined){
            commit('SET_MENU', data);
        }else{
            commit('SET_TOGGLE');
        }
    },

    setError({ commit }, data) {
        commit('SET_ERROR', data);
    },

    setSuccess({ commit }, data) {
        commit('SET_SUCCESS', data);
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}